import { ToastOptions, toastController } from '@ionic/core';
import { translate } from './translate';
import { Capacitor } from '@capacitor/core';

export async function showGlobalToast(options: ToastOptions) {
  const toast = await toastController.create(options);
  return await toast.present();
}


export async function showNewVersionAvailableToast() {
  const toast = await toastController.create({
    message: translate('NEW_VERSION_AVAILABLE'),
    buttons: [
      {
        text: translate('DISMISS'),
        side: 'end',
        role: 'cancel',
      },
      {
        text: translate('RELOAD'),
        side: 'end',
        handler: () => {
          reloadApp();
        },
      },
    ],
    color: 'dark',
  });
  toast.present();
}

export async function reloadApp() {
  if (Capacitor.isNativePlatform()) {
    // const reloading = await Deploy.reloadApp();
    // if (reloading) return;
    return window.location.reload();
  } else {
    const registration = await navigator.serviceWorker.getRegistration();
    if (!registration || !registration.waiting) {
      // If there is no registration, this is the first service
      // worker to be installed. registration.waiting is the one
      // waiting to be activiated.
      return window.location.reload();
    } else {
      registration.waiting.postMessage('skipWaiting');
      return window.location.reload();
    }
  }
}
